// ---------------------------
// Inline SVG icons used in UI
// ---------------------------
const ICONS = {
  pin: '<svg width="29" height="36" viewBox="0 0 29 36" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6325 35.1768L13.755 35.2468L13.804 35.2748C13.9983 35.3798 14.2157 35.4348 14.4366 35.4348C14.6575 35.4348 14.8749 35.3798 15.0693 35.2748L15.1182 35.2485L15.2425 35.1768C15.927 34.7709 16.5948 34.3377 17.2445 33.8783C18.9264 32.6908 20.4978 31.3543 21.9398 29.8848C25.3418 26.4023 28.875 21.1698 28.875 14.4375C28.875 10.6084 27.3539 6.9362 24.6464 4.22865C21.9388 1.52109 18.2666 0 14.4375 0C10.6084 0 6.9362 1.52109 4.22865 4.22865C1.52109 6.9362 0 10.6084 0 14.4375C0 21.168 3.535 26.4023 6.93525 29.8848C8.37663 31.3542 9.94748 32.6908 11.6288 33.8783C12.279 34.3378 12.9475 34.7709 13.6325 35.1768ZM14.4375 19.6875C15.8299 19.6875 17.1652 19.1344 18.1498 18.1498C19.1344 17.1652 19.6875 15.8299 19.6875 14.4375C19.6875 13.0451 19.1344 11.7098 18.1498 10.7252C17.1652 9.74062 15.8299 9.1875 14.4375 9.1875C13.0451 9.1875 11.7098 9.74062 10.7252 10.7252C9.74062 11.7098 9.1875 13.0451 9.1875 14.4375C9.1875 15.8299 9.74062 17.1652 10.7252 18.1498C11.7098 19.1344 13.0451 19.6875 14.4375 19.6875Z" fill="url(#paint0_linear_4629_1784)"/><defs><linearGradient id="paint0_linear_4629_1784" x1="14.4375" y1="0" x2="14.4375" y2="35.4348" gradientUnits="userSpaceOnUse"><stop stop-color="#163541"/><stop offset="1" stop-color="#457182"/></linearGradient></defs></svg>',
  arrow: '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" fill="none"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m.75.75 7.5 7.5-7.5 7.5"/></svg>',
  close: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none"><path fill="#0A232D" fill-rule="evenodd" d="M.22.239a.75.75 0 0 1 1.06 0l5.47 5.47 5.47-5.47a.75.75 0 1 1 1.06 1.06l-5.47 5.47 5.47 5.47a.75.75 0 1 1-1.06 1.06l-5.47-5.47-5.47 5.47a.75.75 0 0 1-1.06-1.06l5.47-5.47-5.47-5.47a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"/></svg>',
  closeSmall: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"><path fill="#FFF" fill-rule="evenodd" d="M9.75 0A9.75 9.75 0 0 0 0 9.75a9.75 9.75 0 0 0 9.75 9.75 9.75 9.75 0 0 0 9.75-9.75A9.75 9.75 0 0 0 9.75 0ZM8.03 6.97a.75.75 0 1 0-1.06 1.06l1.72 1.72-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06l-1.72-1.72 1.72-1.72a.75.75 0 1 0-1.06-1.06L9.75 8.69 8.03 6.97Z" clip-rule="evenodd"/></svg>',
  info: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"><path fill="#FFF" fill-rule="evenodd" d="M0 9.75A9.75 9.75 0 0 1 9.75 0a9.75 9.75 0 0 1 9.75 9.75 9.75 9.75 0 0 1-9.75 9.75A9.75 9.75 0 0 1 0 9.75Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM9.75 6.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clip-rule="evenodd"/></svg>'
};

// ---------------------------
// Shopify JSON file
// ---------------------------
const cacheVersion = Math.floor(Date.now() / 1800000);
const STOCKISTS_JSON_URL = `https://cdn.shopify.com/s/files/1/0565/7283/8048/files/stockist-locator-data.json?v=${cacheVersion}`;

// ---------------------------
// State
// ---------------------------
let STOCKISTS = [];
let FILTERED_STOCKISTS = null;

let map;
let info;
let bounds;
let userPoint = null;
let userMarker = null;
let activeId = null;

const markers = new Map();

// ---------------------------
// Escape HTML before inserting spreadsheet data into markup
// ---------------------------
function escapeHtml(value) {
  return String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}

// ---------------------------
// Normalise website URLs
// ---------------------------
function normalizeUrl(value) {
  if (!value) return '';

  let url = String(value).trim();

  if (!url || url === '-') return '';

  if (/^(javascript:|data:|vbscript:)/i.test(url)) {
    return '';
  }

  if (/^\/\//.test(url)) {
    url = `https:${url}`;
  } else if (/^http:\/\//i.test(url)) {
    url = url.replace(/^http:\/\//i, 'https://');
  } else if (!/^https:\/\//i.test(url)) {
    url = `https://${url.replace(/^\/+/, '')}`;
  }

  try {
    const parsed = new URL(url);

    if (parsed.protocol !== 'https:') {
      return '';
    }

    return parsed.href;
  } catch {
    return '';
  }
}

// ---------------------------
// Find an element by its data-id
// ---------------------------
function findElementByDataId(selector, id) {
  return Array.from(document.querySelectorAll(selector))
    .find((element) => element.dataset.id === String(id));
}

// ---------------------------
// Set the active list item
// ---------------------------
function setActiveListItem(id) {
  activeId = String(id);

  document
    .querySelectorAll(
      '.stockist-locator__list-item--active, .stockist-locator__list-item.active'
    )
    .forEach((element) => {
      element.classList.remove(
        'stockist-locator__list-item--active',
        'active'
      );

      element.setAttribute('aria-pressed', 'false');
    });

  const element = findElementByDataId(
    '.stockist-locator__list-item',
    activeId
  );

  if (!element) return;

  element.classList.add('stockist-locator__list-item--active');
  element.setAttribute('aria-pressed', 'true');

  element.scrollIntoView({
    block: 'nearest',
    behavior: 'smooth'
  });
}

// ---------------------------
// Load stockists from Shopify JSON
// ---------------------------
async function loadStockists() {
  const response = await fetch(STOCKISTS_JSON_URL);

  if (!response.ok) {
    throw new Error(`Store JSON fetch failed: ${response.status}`);
  }

  const data = await response.json();
  const rows = Array.isArray(data) ? data : [];

  STOCKISTS = rows
    .map((row, index) => {
      const values = row.values ?? {};

      // Excel column positions:
      // 0 = Name
      // 1 = Address
      // 2 = Longitude
      // 3 = Latitude
      // 4 = Website
      // 5 = Phone

      const name = String(values['0'] ?? '').trim();
      const address = String(values['1'] ?? '').trim();
      const phone = String(values['5'] ?? '').trim();

      const lng = Number(
        String(values['2'] ?? '')
          .trim()
          .replace(',', '.')
      );

      const lat = Number(
        String(values['3'] ?? '')
          .trim()
          .replace(',', '.')
      );

      const url = normalizeUrl(
        String(values['4'] ?? '').trim()
      );

      const valid =
        name &&
        address &&
        Number.isFinite(lat) &&
        Number.isFinite(lng) &&
        lat >= -90 &&
        lat <= 90 &&
        lng >= -180 &&
        lng <= 180;

      if (!valid) {
        console.warn('Skipping invalid stockist row:', {
          row,
          name,
          address,
          lat,
          lng
        });

        return null;
      }

      return {
        id: String(index + 1),
        name,
        address,
        lat,
        lng,
        url,
        phone
      };
    })
    .filter(Boolean);

  console.log(`Loaded ${STOCKISTS.length} stockists`);
}

// ---------------------------
// Main map initialisation
// ---------------------------
async function initMap() {
  const mapElement = document.getElementById('map');

  if (!mapElement) {
    console.error('Store locator map element was not found.');
    return;
  }

  await google.maps.importLibrary('maps');
  await google.maps.importLibrary('marker');
  await google.maps.importLibrary('geometry');

  try {
    await loadStockists();
  } catch (error) {
    console.error('Could not load stockists:', error);
    STOCKISTS = [];
    alert('Could not load stockists right now.');
  }

  map = new google.maps.Map(mapElement, {
    center: {
      lat: 54.6,
      lng: -5
    },
    zoom: 5.6,
    mapId: 'e3e5e4223568266dfbe94c28',
    gestureHandling: 'cooperative',
    disableDefaultUI: true,
    zoomControl: true,
    fullscreenControl: false
  });

  map.getDiv().setAttribute('tabindex', '0');

  info = new google.maps.InfoWindow();
  bounds = new google.maps.LatLngBounds();

  STOCKISTS.forEach((stockist) => {
    stockist.pos = new google.maps.LatLng(
      stockist.lat,
      stockist.lng
    );

    const pinContainer = document.createElement('div');
    pinContainer.className = 'stockist-locator__pin';
    pinContainer.dataset.id = stockist.id;
    pinContainer.innerHTML = ICONS.pin;

    const marker = new google.maps.marker.AdvancedMarkerElement({
      map,
      position: stockist.pos,
      title: stockist.name,
      content: pinContainer
    });

    marker.addListener('click', () => {
      focusMarker(stockist.id);
    });

    markers.set(stockist.id, marker);
    bounds.extend(stockist.pos);
  });

  if (!bounds.isEmpty()) {
    map.fitBounds(bounds, 60);

    google.maps.event.addListenerOnce(map, 'idle', () => {
      if (map.getZoom() > 12) {
        map.setZoom(12);
      }
    });
  }

  const useLocationButton = document.getElementById('useMyLocation');

  useLocationButton?.addEventListener(
    'click',
    useMyLocation
  );

  const searchForm = document.getElementById('searchForm');

  searchForm?.addEventListener('submit', (event) => {
    event.preventDefault();

    const query = String(
      new FormData(searchForm).get('q') ?? ''
    ).trim();

    handleSearch(query);
  });

  initialiseSidebarToggle();
  refreshList();
}

// ---------------------------
// Open a Google Maps info window
// ---------------------------
function openInfo(stockist) {
  if (!info || !map) return;

  const wrapper = document.createElement('div');
  wrapper.className = 'stockist-locator__infobox';

  const title = document.createElement('div');
  title.className = 'stockist-locator__infobox-title';
  title.textContent = stockist.name;

  const address = document.createElement('div');
  address.className = 'stockist-locator__infobox-address';
  address.textContent = stockist.address;

  wrapper.append(title, address);

  if (userPoint) {
    const distance = document.createElement('div');
    distance.className = 'stockist-locator__infobox-distance';
    distance.textContent =
      `${distanceMiles(userPoint, stockist.pos).toFixed(1)} miles away`;

    wrapper.appendChild(distance);
  }

  const marker = markers.get(stockist.id);

  if (!marker) return;

  info.setContent(wrapper);
  info.open({
    anchor: marker,
    map
  });
}

// ---------------------------
// Normalise text for searching
// ---------------------------
function normalizeSearchText(value) {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

function updateMarkerVisibility(stockists = STOCKISTS) {
  const visibleIds = new Set(
    stockists.map((stockist) => stockist.id)
  );

  markers.forEach((marker, id) => {
    marker.map = visibleIds.has(id) ? map : null;
  });
}

// ---------------------------
// Search by stockist name first,
// then fall back to address geocoding
// ---------------------------
function handleSearch(query) {
  if (!query) {
    FILTERED_STOCKISTS = null;
    refreshList();

    if (bounds && !bounds.isEmpty()) {
      map.fitBounds(bounds, 60);
    }

    return;
  }

  const normalizedQuery = normalizeSearchText(query);

  const nameMatches = STOCKISTS.filter((stockist) =>
    normalizeSearchText(stockist.name).includes(normalizedQuery)
  );

  if (nameMatches.length > 0) {
    FILTERED_STOCKISTS = nameMatches;
    refreshList();
    fitMapToStockists(nameMatches);
    return;
  }

  // No name matches: treat the query as a city, address or postcode.
  FILTERED_STOCKISTS = null;
  geocodeAddress(query);
}

// ---------------------------
// Fit the map to selected stockists
// ---------------------------
function fitMapToStockists(stockists) {
  if (!map || !stockists.length) return;

  const searchBounds = new google.maps.LatLngBounds();

  stockists.forEach((stockist) => {
    if (stockist.pos) {
      searchBounds.extend(stockist.pos);
    }
  });

  if (searchBounds.isEmpty()) return;

  map.fitBounds(searchBounds, 60);

  google.maps.event.addListenerOnce(map, 'idle', () => {
    if (map.getZoom() > 15) {
      map.setZoom(15);
    }
  });
}

// ---------------------------
// Geocode an entered address
// ---------------------------
function geocodeAddress(query) {
  if (!query || !map) return;

  const geocoder = new google.maps.Geocoder();

  const request = {
    address: query
  };

  if (bounds && !bounds.isEmpty()) {
    request.bounds = bounds;
  }

  geocoder
    .geocode(request)
    .then(({ results }) => {
      const location = results?.[0]?.geometry?.location;

      if (!location) {
        alert('No results found for that address.');
        return;
      }

      setUserPoint(location);
    })
    .catch((error) => {
      console.error('Geocoding failed:', error);
      alert('There was a problem geocoding that address.');
    });
}

// ---------------------------
// Set the user's location
// ---------------------------
function setUserPoint(latLng) {
  if (!map) return;

  userPoint = latLng;
  FILTERED_STOCKISTS = null;

  if (!userMarker) {
    const element = document.createElement('div');
    element.className = 'stockist-locator__user-dot';

    userMarker =
      new google.maps.marker.AdvancedMarkerElement({
        map,
        position: userPoint,
        title: 'Your location',
        content: element
      });
  } else {
    userMarker.position = userPoint;
  }

  zoomToShowNearestStore();
  refreshList();
}

// ---------------------------
// Get the user's browser location
// ---------------------------
function useMyLocation() {
  if (!navigator.geolocation) {
    alert('Geolocation is not supported by your browser.');
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (position) => {
      const location = new google.maps.LatLng(
        position.coords.latitude,
        position.coords.longitude
      );

      setUserPoint(location);
    },
    (error) => {
      console.error('Geolocation failed:', error);
      alert(`Could not get your location: ${error.message}`);
    },
    {
      enableHighAccuracy: true,
      maximumAge: 15000,
      timeout: 10000
    }
  );
}

// ---------------------------
// Refresh the stockist list
// ---------------------------
function refreshList() {
  const results = document.getElementById('results');

  if (!results) return;

  results.replaceChildren();

  const sourceStockists = FILTERED_STOCKISTS ?? STOCKISTS;
  const items = sourceStockists
    .map((stockist) => ({
      ...stockist,
      dist: userPoint
        ? distanceMiles(userPoint, stockist.pos)
        : null
    }))
    .sort((a, b) => {
      if (a.dist == null || b.dist == null) {
        return a.name.localeCompare(b.name);
      }

      return a.dist - b.dist;
    });

  const fragment = document.createDocumentFragment();

  items.forEach((stockist) => {
    fragment.appendChild(renderListItem(stockist));
  });

  results.appendChild(fragment);

  scrollResultsToTop();
  hideDetailPanel();
}

// ---------------------------
// Render a stockist list item
// ---------------------------
function renderListItem(stockist) {
  const root = document.createElement('button');

  root.type = 'button';
  root.className = 'stockist-locator__list-item';
  root.dataset.id = stockist.id;
  root.setAttribute('aria-pressed', 'false');

  if (stockist.id === activeId) {
    root.classList.add(
      'stockist-locator__list-item--active'
    );

    root.setAttribute('aria-pressed', 'true');
  }

  root.addEventListener('click', () => {
    focusMarker(stockist.id);
  });

  const title = document.createElement('div');
  title.className = 'stockist-locator__list-title';
  title.textContent = stockist.name;

  const subtitle = document.createElement('div');
  subtitle.className = 'stockist-locator__list-subtitle';
  subtitle.textContent = stockist.address;

  root.append(title, subtitle);

  if (stockist.dist != null) {
    const distance = document.createElement('div');
    distance.className = 'stockist-locator__distance';
    distance.textContent =
      `${stockist.dist.toFixed(1)} miles away`;

    root.appendChild(distance);
  }

  const arrow = document.createElement('div');
  arrow.className = 'stockist-locator__list-arrow';
  arrow.innerHTML = ICONS.arrow;

  root.appendChild(arrow);

  return root;
}

// ---------------------------
// Focus a stockist
// ---------------------------
function focusMarker(id) {
  const stockist = STOCKISTS.find(
    (item) => item.id === String(id)
  );

  if (!stockist || !map) return;

  setActiveListItem(stockist.id);

  document
    .querySelectorAll('.stockist-locator__pin--active')
    .forEach((element) => {
      element.classList.remove(
        'stockist-locator__pin--active'
      );
    });

  const activePin = findElementByDataId(
    '.stockist-locator__pin',
    stockist.id
  );

  activePin?.classList.add(
    'stockist-locator__pin--active'
  );

  map.panTo(stockist.pos);
  map.setZoom(15);

  info?.close();

  showDetailPanel(stockist);
  map.getDiv().focus();
}

// ---------------------------
// Calculate distance in miles
// ---------------------------
function distanceMiles(pointA, pointB) {
  return (
    google.maps.geometry.spherical.computeDistanceBetween(
      pointA,
      pointB
    ) / 1609.344
  );
}

// ---------------------------
// Format UK telephone numbers
// ---------------------------
function normalizeUkPhone(phone) {
  if (!phone || phone === '-') return '';

  const cleaned = String(phone)
    .trim()
    .replace(/(?!^\+)[^\d]/g, '');

  if (!cleaned) return '';

  if (cleaned.startsWith('+44')) {
    return cleaned;
  }

  if (cleaned.startsWith('44')) {
    return `+${cleaned}`;
  }

  if (cleaned.startsWith('0')) {
    return `+44${cleaned.slice(1)}`;
  }

  if (/^\d{10}$/.test(cleaned)) {
    return `+44${cleaned}`;
  }

  return '';
}

// ---------------------------
// Render the store details panel
// ---------------------------
function renderDetailHTML(stockist) {
  const hasValue = (value) => {
    return Boolean(value && value !== '-');
  };

  const safeName = escapeHtml(stockist.name);
  const safeAddress = escapeHtml(stockist.address);
  const safeUrl = escapeHtml(stockist.url);

  const normalizedPhone = normalizeUkPhone(
    stockist.phone
  );

  const isValidPhone =
    /^\+44\d{9,10}$/.test(normalizedPhone);

  const telHref = isValidPhone
    ? `tel:${normalizedPhone}`
    : '';

  const displayPhone = isValidPhone
    ? escapeHtml(
        normalizedPhone.replace(/^\+44/, '0')
      )
    : '';

  let websiteHost = '';

  if (stockist.url) {
    try {
      websiteHost = new URL(stockist.url).host;
    } catch {
      websiteHost = stockist.url.replace(
        /^https?:\/\//,
        ''
      );
    }
  }

  websiteHost = escapeHtml(websiteHost);

  return `
    <div class="store-detail">
      <div class="store-detail__container">
        <div class="store-detail__header">
          <button
            type="button"
            class="store-detail__close"
            aria-label="Close store details"
          >
            ${ICONS.close}
          </button>
        </div>

        <div class="store-detail__hero">
          <h3 class="store-detail__title">
            ${safeName}
          </h3>

          <div class="store-detail__address">
            ${safeAddress}
          </div>
        </div>

        <div class="store-detail__quick-actions full">
          ${
            hasValue(stockist.url)
              ? `
                <a
                  class="button button--primary"
                  href="${safeUrl}"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Open website for ${safeName}"
                >
                  Website
                </a>
              `
              : `
                <button
                  class="button button--primary"
                  type="button"
                  disabled
                >
                  Website
                </button>
              `
          }
        </div>

        <div class="store-detail__section">
          <h4 class="store-detail__section-title h6">
            Details
          </h4>

          ${
            telHref
              ? `
                <div class="store-detail__row">
                  <div class="store-detail__label caption">
                    Phone Number
                  </div>

                  <a
                    class="store-detail__value caption"
                    href="${telHref}"
                  >
                    ${displayPhone}
                  </a>
                </div>
              `
              : ''
          }

          ${
            hasValue(stockist.url)
              ? `
                <div class="store-detail__row">
                  <div class="store-detail__label caption">
                    Website
                  </div>

                  <a
                    class="store-detail__value caption"
                    href="${safeUrl}"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ${websiteHost}
                  </a>
                </div>
              `
              : ''
          }
        </div>
      </div>
    </div>
  `;
}

// ---------------------------
// Detail panel keyboard handler
// ---------------------------
function handleDetailKeydown(event) {
  if (event.key === 'Escape') {
    hideDetailPanel();
  }
}

// ---------------------------
// Show the details panel
// ---------------------------
function showDetailPanel(stockist) {
  const panel = document.getElementById('storeDetail');

  if (!panel) return;

  panel.innerHTML = renderDetailHTML(stockist);
  panel.hidden = false;
  panel.setAttribute('aria-hidden', 'false');

  panel
    .querySelector('.store-detail__close')
    ?.addEventListener('click', hideDetailPanel);

  document.removeEventListener(
    'keydown',
    handleDetailKeydown
  );

  document.addEventListener(
    'keydown',
    handleDetailKeydown
  );

  updateBodyScrollLock();
  hideNoStoreNearbyMessage();
}

// ---------------------------
// Hide the details panel
// ---------------------------
function hideDetailPanel() {
  const panel = document.getElementById('storeDetail');

  if (!panel) return;

  panel.hidden = true;
  panel.setAttribute('aria-hidden', 'true');

  document.removeEventListener(
    'keydown',
    handleDetailKeydown
  );

  updateBodyScrollLock();
}

// ---------------------------
// Scroll the results list to the top
// ---------------------------
function scrollResultsToTop() {
  const results = document.getElementById('results');

  const scroller =
    results?.closest(
      '.stockist-locator__sidebar-inner'
    ) || results;

  if (!scroller) return;

  requestAnimationFrame(() => {
    scroller.scrollTop = 0;
  });
}

// ---------------------------
// Initialise the mobile sidebar toggle
// ---------------------------
function initialiseSidebarToggle() {
  const toggleButton = document.querySelector(
    '.stockist-locator__toggle-list'
  );

  const sidebar = document.querySelector(
    '.stockist-locator__sidebar'
  );

  const container = sidebar?.parentElement;

  if (!toggleButton || !sidebar || !container) {
    return;
  }

  toggleButton.addEventListener('click', () => {
    container.classList.toggle('active');
    toggleButton.classList.toggle('active');

    const isActive =
      container.classList.contains('active');

    toggleButton.setAttribute(
      'aria-pressed',
      String(isActive)
    );

    sidebar.scrollIntoView({
      behavior: 'auto',
      block: isActive ? 'start' : 'end'
    });
  });
}

// ---------------------------
// Body scroll lock
// ---------------------------
function updateBodyScrollLock() {
  const detailPanel =
    document.getElementById('storeDetail');

  const detailOpen =
    Boolean(detailPanel && detailPanel.hidden === false);

  document.body.classList.toggle(
    'no-scroll',
    detailOpen
  );
}

// ---------------------------
// Get the nearest stockists
// ---------------------------
function getNearestStores(count = 3) {
  if (!userPoint || !STOCKISTS.length) {
    return [];
  }

  return STOCKISTS
    .filter((stockist) => stockist.pos)
    .map((stockist) => ({
      ...stockist,
      distanceMeters:
        google.maps.geometry.spherical
          .computeDistanceBetween(
            userPoint,
            stockist.pos
          )
    }))
    .sort(
      (a, b) =>
        a.distanceMeters - b.distanceMeters
    )
    .slice(0, count);
}

// ---------------------------
// Zoom to user and nearest stockists
// ---------------------------
function zoomToShowNearestStore() {
  if (!map || !userPoint) return;

  const nearestStores = getNearestStores(3);

  if (!nearestStores.length) return;

  const nearestDistanceKm =
    nearestStores[0].distanceMeters / 1000;

  if (nearestDistanceKm > 5) {
    showNoStoreNearbyMessage();
  } else {
    hideNoStoreNearbyMessage();
  }

  const nearestBounds =
    new google.maps.LatLngBounds();

  nearestBounds.extend(userPoint);

  nearestStores.forEach((stockist) => {
    nearestBounds.extend(stockist.pos);
  });

  map.fitBounds(nearestBounds, 60);

  google.maps.event.addListenerOnce(
    map,
    'idle',
    () => {
      const zoom = map.getZoom();

      if (zoom < 5) {
        map.setZoom(5);
      }

      if (zoom > 16) {
        map.setZoom(16);
      }
    }
  );
}

// ---------------------------
// Show the no-nearby-store message
// ---------------------------
function showNoStoreNearbyMessage() {
  const element = document.getElementById(
    'noStoreMessage'
  );

  if (!element) return;

  const message = escapeHtml(
    window.labels?.noStoreMessage ||
      'There are no stockists nearby.'
  );

  element.innerHTML = `
    ${ICONS.info}

    <span>${message}</span>

    <button
      class="button--plain"
      type="button"
      aria-label="Close message"
    >
      ${ICONS.closeSmall}
    </button>
  `;

  element
    .querySelector('button')
    ?.addEventListener(
      'click',
      hideNoStoreNearbyMessage
    );

  element.hidden = false;
}

// ---------------------------
// Hide the no-nearby-store message
// ---------------------------
function hideNoStoreNearbyMessage() {
  const element = document.getElementById(
    'noStoreMessage'
  );

  if (!element) return;

  element.hidden = true;
}

// ---------------------------
// Google Maps callback
// ---------------------------
window.initMap = initMap;